import React from 'react'

import Doctors from 'presentation/hospital/pages/Doctors'

export default function makeHospitalDoctors() {
  return <Doctors />
}
